var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecycled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "49px",
    viewBox: "0 0 53 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recycled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2505154,20.0651028 L51.3978479,28.5683946 L42.1117847,43.3271176 L30.9195237,43.3527449 L30.5914465,47.7865275 L24.1922048,37.8678344 L31.9610956,29.5503256 L31.3410876,33.7427974 L47.5973375,33.6439716 L40.700529,29.8161868 L38.1172555,24.5196913 L47.2505154,20.0651028 Z M13.9533033,15.4373244 L18.0233731,26.066113 L14.5269981,23.6709949 L7.48955119,38.3253378 L13.9533033,33.8045179 L19.8461944,33.8045179 L19.8461944,43.9662005 L10.3854155,43.9662005 L1.19110523,29.1501439 L6.07443589,19.079372 L2.23319808,16.8408558 L13.9533033,15.4373244 Z M34.6601378,0.899681173 L40.9400168,10.1641555 L44.7992476,7.95680409 L40.1546888,18.8084786 L28.9148529,17.0188682 L32.7372736,15.1884777 L23.5649637,1.76669839 L24.2482327,9.62488189 L21.3017871,14.7282753 L12.5015118,9.64743396 L17.2319012,1.45415911 L34.6601378,0.899681173 Z",
    id: "Recycled",
    stroke: "#000000",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycled);
export default __webpack_public_path__ + "static/media/recycled.d2abf96cf153c46cc1b20193a1d7e599.svg";
export { ForwardRef as ReactComponent };